<template>
  <layout-admin current="subscriptions">
    <div class="panel">
      <div class="panel__head">
        <h1>Subscriptions</h1>
        <span>{{ subscriptions.length }}</span>
      </div>

      <div v-if="!subscriptions.length" class="panel__empty">No subscriptions yet.</div>

      <div v-else class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Client</th>
              <th>Name</th>
              <th>Project</th>
              <th>Next billed</th>
              <th>Interval</th>
              <th>Period</th>
              <th>Active</th>
              <th>Items</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="subscription in subscriptions" :key="subscription.id">
              <td>
                <Link
                  v-if="subscription.client"
                  :href="route('admin.invoices.index', { client: subscription.client.id })"
                  class="link"
                >
                  {{ subscription.client.name }}
                </Link>
                <span v-else>—</span>
              </td>
              <td>{{ subscription.name }}</td>
              <td>
                <template v-if="subscription.project">
                  <div>{{ subscription.project.domain }}</div>
                  <div class="muted mono">{{ subscription.project.code }}</div>
                </template>
                <span v-else>—</span>
              </td>
              <td>{{ formatDate(subscription.next_billed_at) }}</td>
              <td>{{ intervalLabel(subscription.interval_months) }}</td>
              <td>
                <select
                  class="period-select"
                  :value="subscription.period_alignment"
                  :disabled="acting"
                  @change="onAlignmentChange(subscription, $event)"
                >
                  <option
                    v-for="alignment in period_alignments"
                    :key="alignment.value"
                    :value="alignment.value"
                  >
                    {{ alignment.label }}
                  </option>
                </select>
              </td>
              <td>
                <span class="pill" :class="subscription.active ? 'is-on' : 'is-off'">
                  {{ subscription.active ? 'Yes' : 'No' }}
                </span>
              </td>
              <td class="wrap">
                <div v-for="item in subscription.items" :key="item.id" class="item">
                  {{ item.title }}
                  · {{ item.quantity }} × {{ money(item.rate) }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </layout-admin>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
import LayoutAdmin from '@/Layouts/Admin.vue';

export default {
  components: {
    LayoutAdmin,
    Link
  },

  props: {
    subscriptions: { type: Array, required: true },
    period_alignments: { type: Array, required: true }
  },

  data() {
    return {
      acting: false
    };
  },

  methods: {
    onAlignmentChange(subscription, event) {
      const value = event.target.value;
      if (value === subscription.period_alignment) return;
      this.acting = true;
      this.$inertia.post(
        route('admin.invoices.subscriptions.period-alignment', subscription.id),
        { period_alignment: value },
        {
          preserveScroll: true,
          onFinish: () => {
            this.acting = false;
          }
        }
      );
    },
    formatDate(value) {
      if (!value) return '—';
      const date = new Date(value + 'T00:00:00');
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    },

    intervalLabel(months) {
      const n = Number(months) || 0;
      if (n === 1) return 'Monthly';
      if (n === 12) return 'Annual';
      if (n === 24) return '2 years';
      return n + ' months';
    },

    money(value) {
      const num = Number(value);
      if (!Number.isFinite(num)) return '—';
      const formatted = Math.abs(num).toLocaleString('en-MY', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return (num < 0 ? '- ' : '') + 'RM ' + formatted;
    }
  }
};
</script>
